// Determine the hostname dynamically if in the browser, fallback to production default
const hostname = typeof window !== 'undefined' ? window.location.hostname : "zenonlinestore.zentexus.in";

let API_DOMAIN;
let subdomain;

if (hostname === "localhost" || hostname === "127.0.0.1") {
  subdomain = "demoonlinepropertystore"; // Default local tenant
  API_DOMAIN = "https://demoonlinepropertystore.zentexus.in/api";
} else {
  // Break into domain parts
  let parts = hostname.split(".");

  // Handle www
  if (parts[0] === "www") parts.shift();

  // Default tenant
  const defaultSubdomain = "zenonlinestore";

  subdomain =
    parts.length > 2
      ? parts[0]               // giftworldsattur.zentexus.in
      : parts.length === 2
        ? defaultSubdomain       // zentexus.in
        : parts[0] || defaultSubdomain; // fallback case

  API_DOMAIN = `https://${subdomain}.zentexus.in/api`;
}

// console.log("Configured API_DOMAIN:", API_DOMAIN);
// console.log("Configured subdomain:", subdomain);

export default { API_DOMAIN, subdomain };


